import { useNavigate } from 'react-router-dom'
import { Bell, User, Shield, LogOut } from 'lucide-react'
import { useApp } from '../context/AppContext'

export default function Header() {
  const navigate = useNavigate()
  const { currentUser, setCurrentUser, users, stats } = useApp()

  return (
    <header className="h-14 bg-white border-b border-slate-200 flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        <h1 className="text-lg font-semibold text-slate-800">GPTs / Gemini Gems 迁移中台</h1>
        <span className="text-xs px-2 py-1 bg-slate-100 text-slate-600 rounded-full">v1.0</span>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 text-sm text-slate-600">
          <Shield size={14} />
          <span>角色: {currentUser?.role}</span>
        </div>

        <div className="relative">
          <Bell size={18} className="text-slate-500 cursor-pointer hover:text-slate-700" />
          {stats.pendingReviews > 0 && (
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center">
              {stats.pendingReviews}
            </span>
          )}
        </div>

        <select
          className="text-sm border border-slate-300 rounded-lg px-2 py-1 bg-white"
          value={currentUser?.id}
          onChange={(e) => {
            const user = users.find(u => u.id === e.target.value)
            if (user) setCurrentUser(user)
          }}
        >
          {users.map(u => (
            <option key={u.id} value={u.id}>{u.name} ({u.role})</option>
          ))}
        </select>
      </div>
    </header>
  )
}
